<form [formGroup]="parentAddressInfoForm" class="w-100" style="position: relative">
  <div class="ui form">
    <div class="field">
      <label>Address</label>
      <input formControlName="address" type="text" placeholder="Eg: 21, Bolaji Banwo street" />
    </div>
    <div class="field">
      <!-- -->

      

      <div class="field">
        <label>State</label>
        <select
          (change)="selectLgaInState($event.target.value)"
          style="height: auto;"
          class="ui fluid search dropdown"
          name="card[expire-month]"
          formControlName="state"
        >
          <option value="" selected>Select state...</option>
          <option
            [value]="state.id"
            *ngFor="let state of NigerianStates; index as i"
          >
            {{ state.value }}
          </option>
        </select>
      </div>

      <div class="field">
        <label>LGA </label>
        <select
          style="height: auto;"
          class="ui fluid search dropdown"
          name="card[expire-month]"
          formControlName="lga"
        >
          <option value="" selected>Select Local Govt Area...</option>
          <option [value]="lga.id" *ngFor="let lga of stateLgas; index as i">
            {{ lga.value }}
          </option>
        </select>
      </div>

      <div class="field">
        <label>Number of years in current residence</label>
        <input  formControlName="resident_years" name="class" 
        type="tel" (keypress)="generalservice.numberOnly($event)" placeholder="Eg: 2" 
        autocomplete="off"/>
      </div>
    </div>
  </div>

  <div class="text-center mt-4">
    <button
      [disabled]="!parentAddressInfoForm.valid"
      (click)="submitThisForm(parentAddressInfoForm)"
      type="button"
      class="ui primary button fluid"
    >
     <i *ngIf="fetchingSummary" class="fa fa-circle-notch fa-spin mr-2"></i> Next
    </button>
  </div>

  <div *ngIf="spinner" class="spinner-container">
    <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
    <app-loader></app-loader>
  </div>
</form>
